/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { GitHubButton } from "components/atoms/GitHubButton/GitHubButton";

export type SNSTextIconsType = {
  github: {
    href: string;
  };
};

export type SNSTextIconsProps = {
  color?: string;
  iconProps: SNSTextIconsType;
};

export const SNSTextIcons: React.FC<SNSTextIconsProps> = ({
  iconProps,
  color = "#666666",
}: SNSTextIconsProps) => {
  const { github } = iconProps;

  return (
    <div
      css={css`
        display: flex;
      `}
    >
      {/* GitHub */}
      <a
        css={css`
          display: block;
          color: ${color};
        `}
        href={github.href}
        target="_blank"
        rel="noreferrer"
      >
        <GitHubButton color={color} />
      </a>
    </div>
  );
};
